import giftIcon from "@assets/icon-gift.svg";
import Button from "@components/AccessibleComponents/Button";
import { OKTAUserTypeEnum } from "@store/useOKTAUserStore";

export type ArticleSubshareProps = {
  testId?: string;
  isPremium: boolean;
  userType?: OKTAUserTypeEnum;
  setShowGiftSent: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ArticleSubshare({
  isPremium = false,
  userType = OKTAUserTypeEnum.ANONYMOUS,
  setShowGiftSent,
}: ArticleSubshareProps): React.ReactElement {
  return (
    <>
      {isPremium && userType === OKTAUserTypeEnum.SUBSCRIBER ? (
        <div data-testid="article-subshare-component">
          <Button
            onPress={() => {
              setShowGiftSent(true);
            }}
            className="outline-none hover:opacity-70"
            aria-label="Gift this subscriber-only story to your friends and family"
          >
            <img
              src={giftIcon}
              width={40}
              height={40}
              alt="Share this article."
            />
          </Button>
        </div>
      ) : null}
    </>
  );
}
